module.exports = __webpack_public_path__ + "media/images/plans/plan-icon-moderator-79d7654b8be665615cf1cd5d621bfde8.png";